import { render, staticRenderFns } from "./WorkPercentageTextField.vue?vue&type=template&id=80c38fd4&scoped=true"
import script from "./WorkPercentageTextField.vue?vue&type=script&lang=js"
export * from "./WorkPercentageTextField.vue?vue&type=script&lang=js"
import style0 from "./WorkPercentageTextField.vue?vue&type=style&index=0&id=80c38fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c38fd4",
  null
  
)

export default component.exports